.c-vacation-calculator-disclaimer {
  margin: 2em 0;
}

  .c-vacation-calculator-disclaimer small {
    color: #52525b;
    padding-bottom: 1em;
  }

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC9jb21wb25lbnRzL3ZhY2F0aW9uX2NhbGN1bGF0b3IvZGlzY2xhaW1lcl9jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBYTtBQU1mOztFQUpFO0lBQ0UsY0FBK0I7SUFDL0IsbUJBQW1CO0VBQ3JCIiwiZmlsZSI6ImFwcC9jb21wb25lbnRzL3ZhY2F0aW9uX2NhbGN1bGF0b3IvZGlzY2xhaW1lcl9jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmMtdmFjYXRpb24tY2FsY3VsYXRvci1kaXNjbGFpbWVyIHtcbiAgbWFyZ2luOiAyZW0gMDtcblxuICBzbWFsbCB7XG4gICAgY29sb3I6IHRoZW1lKCdjb2xvcnMuZ3JheS42MDAnKTtcbiAgICBwYWRkaW5nLWJvdHRvbTogMWVtO1xuICB9XG59XG4iXX0= */